import React, { ReactElement } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import Card from '../../ui/Card';
import clsx from 'clsx';
import s from './styles/dragAndDrop.module.scss';

const reorder = (list: Array<InitialItems>, startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export interface InitialItems {
    id: number;
    content: string | ReactElement;
}

interface IDragAndDropProps {
    itemsList: Array<InitialItems>;
    updateItemsList: (item: Array<InitialItems>) => void;
}

const DragAndDrop = ({ itemsList = [], updateItemsList }: IDragAndDropProps) => {
    const onDragEnd = (result: DropResult) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(itemsList, result.source.index, result.destination.index);

        updateItemsList(items);
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {itemsList.map((item, index) => (
                            <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                                {(provided, snapshot) => (
                                    <Card
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={clsx(s.item, snapshot.isDragging && s.itemActive)}
                                        style={provided.draggableProps.style}
                                    >
                                        {item.content}
                                    </Card>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};
export default DragAndDrop;
